module.exports = __webpack_public_path__ + "img/interior_18.96a14708.jpg";